export function timeString() {
    let now = new Date();
    let hour = now.getHours();
    let str;
    if (hour < 6) { str = "凌晨好！" }
    else if (hour < 9) { str = "早上好！" }
    else if (hour < 12) { str = "上午好！" }
    else if (hour < 14) { str = "中午好！" }
    else if (hour < 17) { str = "下午好！" }
    else if (hour < 19) { str = "傍晚好！" }
    else if (hour < 22) { str = "晚上好！" }
    else { str = "夜里好！" }

    return str;
}

export function format(fmt) {
    let now = new Date();
    var o = {
        "M+": now.getMonth() + 1,                 //月份   
        "d+": now.getDate(),                    //日   
        "h+": now.getHours(),                   //小时   
        "m+": now.getMinutes(),                 //分   
        "s+": now.getSeconds(),                 //秒   
        "q+": Math.floor((now.getMonth() + 3) / 3), //季度   
        "S": now.getMilliseconds()             //毫秒   
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (now.getFullYear() + "").substring(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substring(("" + o[k]).length)));
    return fmt;
}



// WEBPACK FOOTER //
// ./src/libs/date.js